import styled from "styled-components"
import { HelperText } from "ui/base/helperText/HelperText"
import { BlueTicket } from "ui/icons/BlueTicket.jsx"

export const ResetPasswordSuccess = ({
    onBackToLogin,
}) => {
    return (
        <LoginLeftContainer>
            <LoginTextContainer>
                <BlueTicket width={80} height={80} />
            </LoginTextContainer>

            <HelperText size='h5' sizeMobile='large' weight={600} centerMobile center>
                Your password has been changed successfully
            </HelperText>

            <LoginFormContainer>
                <HelperText
                    color='placeholder'
                    centerMobile
                    center
                    style={{ cursor: "pointer" }}
                    onClick={onBackToLogin}
                >
                    Back to login
                </HelperText>

            </LoginFormContainer>
        </LoginLeftContainer>
    )
}

const LoginLeftContainer = styled.div`
  display: grid;
  gap: 30px;
  width: 100%;
  max-width: 450px;
  margin-inline: auto;
  font-family: var(--font-secondary);
`

const LoginTextContainer = styled.div`
  display: grid;
  gap: 1rem;
  margin-inline: auto;
`

const LoginFormContainer = styled.div`
  display: grid;
  gap: 1rem;
`
